var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2078,
    height: 2079,
    viewBox: "0 0 2078 2079",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_69_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1728 1039.5C1728 1420.3 1419.54 1729 1039 1729C658.48 1729 350 1420.3 350 1039.5C350 658.7 658.48 350 1039 350C1419.54 350 1728 658.7 1728 1039.5Z",
    fill: "#E9E1FF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_69_11",
    x: 0,
    y: 0,
    width: 2078,
    height: 2079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_69_11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGray);
export default __webpack_public_path__ + "static/media/gray.79eb1cee9e8eb87e9dc4bda37c0c652f.svg";
export { ForwardRef as ReactComponent };